import { FC } from 'react'
import Typography from '@/ui/components/typography'
import { useCustomTheme } from '@/core/theme'

export interface FilterButtonStatusProps {
    filteredCount: number
    totalCount: number
    statusLabel: string
    emptyStatusText?: string
    hasActiveFilters?: boolean
}

const FilterButtonStatus: FC<FilterButtonStatusProps> = ({
    filteredCount,
    totalCount,
    statusLabel,
    emptyStatusText,
    hasActiveFilters = false,
}) => {
    const theme = useCustomTheme()
    const isEmptyWithCustomText = totalCount === 0 && !!emptyStatusText
    const isAllShown =
        filteredCount === totalCount && totalCount > 0 && !hasActiveFilters

    if (isEmptyWithCustomText) {
        return (
            <Typography
                variant="s-regular"
                component="span"
                className="filter-status"
                color={theme.colors.greys[600]}
            >
                {emptyStatusText}
            </Typography>
        )
    }

    if (isAllShown) {
        return (
            <Typography
                variant="s-regular"
                component="span"
                className="filter-status"
                color={theme.colors.greys[600]}
            >
                <Typography
                    variant="s-regular"
                    component="span"
                    color={theme.colors.greys[900]}
                    data-testid="filter-button-status-all-shown"
                >
                    {totalCount}
                </Typography>
                <Typography
                    variant="s-regular"
                    component="span"
                    data-testid="filter-button-status-label"
                >
                    {statusLabel}
                </Typography>
            </Typography>
        )
    }

    return (
        <Typography
            variant="s-regular"
            component="span"
            className="filter-status"
            color={theme.colors.greys[600]}
        >
            <span className="filter-status-count">
                <Typography
                    variant="s-regular"
                    component="span"
                    color={theme.colors.greys[900]}
                    data-testid="filter-button-status-filtered-count"
                >
                    {filteredCount}
                </Typography>
                <Typography
                    variant="s-regular"
                    component="span"
                    data-testid="filter-button-status-total-count"
                >
                    /{totalCount}
                </Typography>
            </span>
            <Typography
                variant="s-regular"
                component="span"
                data-testid="filter-button-status-label"
            >
                {statusLabel}
            </Typography>
        </Typography>
    )
}

export default FilterButtonStatus
